import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useMappingNotifications } from "../../../../../../store/notifications/system/useSelectors";
import { useTemplateNotificationsFetchStatus } from "../../../../../../store/notifications/template/useSelectors";
import {
  useDismissNotification,
  useFetchTemplatesForNotificationsAutofetch,
} from "../../../../../../store/notifications/useActions";
import { isInitialLoadComplete } from "../../../../../../utils/fetching";
import { getLinkToHegMappingPage } from "../../../../../../utils/internalLinksParsing";
import CardList, { CardListProps } from "./CardList";
import { UNEXPANDED_VISIBLE_NOTIFICATIONS } from "./constants";
import { getExtendedTemplateMessages } from "./selectors";

const Container: FC<Props> = (props) => {
  useFetchTemplatesForNotificationsAutofetch();

  const mappingMessages = useMappingNotifications();
  const templateMessages = useSelector(getExtendedTemplateMessages);
  const dismiss = useDismissNotification();

  const fetchStatus = useTemplateNotificationsFetchStatus();
  const waitingForInitialLoad = !isInitialLoadComplete(fetchStatus);

  return (
    <CardList
      {...props}
      mappingMessages={mappingMessages}
      getMappingPageUrl={getLinkToHegMappingPage}
      templateMessages={templateMessages}
      dismissNotification={dismiss}
      unexpandedVisibleCount={UNEXPANDED_VISIBLE_NOTIFICATIONS}
      waitingForInitialLoad={waitingForInitialLoad}
    />
  );
};

export type Props = Pick<CardListProps, "onCardClickSideEffect">;

Container.displayName = `Container(${CardList.displayName})`;
export default Container;
export type ContainerProps = Props;
